module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.form.enabled),
      callback: function($$v) {
        _vm.$set(_vm.form, "enabled", $$v)
      },
      expression: "form.enabled"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Set Point (inHg)"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form.setPoint),
      callback: function($$v) {
        _vm.$set(_vm.form, "setPoint", $$v)
      },
      expression: "form.setPoint"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Deadband (inHg)"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form.deadband),
      callback: function($$v) {
        _vm.$set(_vm.form, "deadband", $$v)
      },
      expression: "form.deadband"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db806210"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/settings/Differential.vue
// module id = 1414
// module chunks = 1